import {
  IGridTableCellDispatcher,
  IGridTableHeaderModel,
} from '@types-custom/models/ui/grid-table-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { CardActionEnum } from '@types-custom/models/ui/panel-manage-model';
import { IconComponent } from '@ui-core/controls/icon/icon.component';
import { StateIndicatorComponent } from '@ui-core/controls/state-indicator/state-indicator.component';
import { StateToogleComponent } from '@ui-core/controls/state-toogle/state-toogle.component';
import { Subject } from 'rxjs';

export enum GridTypeEnum {
  Situations = 'Situations',
  UserManage = 'UserManage',
  ManageCameras = 'ManageCameras',
  ManagePMV = 'manage-pmv',
  ManageSensors = 'ManageSensors',
  ManageVariableMessaging = 'Manage-variable-messaging',
  ManageIncidents = 'ManageIncidents',
  PMVconsulta = 'PMVconsulta',
  PMVEditar = 'PMVEditar',
  PMVEditarProgramados = 'PMVEditarProgramados',
  RoleManage = 'RoleManage',
  ManageUserAudit = 'ManageUserAudit',
  ManageRecordAudit = 'ManageRecordAudit',
  ManageGridUserAudit = 'ManageGridUserAudit',
  ManageGridRecordAudit = 'ManageGridRecordAudit',
}

  export const gridTableheadersMap = (
    dispatchers?: Subject<IGridTableCellDispatcher>[]
  ): { [key: string]: IGridTableHeaderModel[] } => ({
    [GridTypeEnum.Situations]: [
      { key: 'SituationDate', label: 'Fecha' },
      { key: 'CodeDeparment', label: 'Departamento' },
      { key: 'CodeCity', label: 'Municipio' },
      { key: 'SituationType', label: 'Clase de Situación' },
      { key: 'SubType', label: 'Tipo de Situación' },
    ],
    [GridTypeEnum.UserManage]: [
      { key: 'name', label: 'Nombres' },
      { key: 'lastName', label: 'Apellidos' },
      { key: 'email', label: 'Correo electrónico' },
      { key: 'rolNames', label: 'Rol', cellClass: 'wb-break-all wb-md-unset' },
      {
        key: 'stateIndicatorProperties',
        label: 'Estado',
        toRender: {
          component: StateIndicatorComponent,
        },
      }
    ],
    [GridTypeEnum.ManageCameras]: [
      { key: 'id', label: 'Id', cellInteger: true },
      { key: 'name', label: 'Nombre' },
      { key: 'address', label: 'Localización' },
      { key: 'cameraTypeName', label: 'Tipo' },
      { key: 'statusName', label: 'Estado' },
      {
        key: undefined, label: 'Acciones', cellClass: 'cursor-pointer fx-cell-hover',
        dispatcher: dispatchers?.at(0),
      },
    ],
    [GridTypeEnum.ManageSensors]: [
      { key: 'id', label: 'Id', cellInteger: true },
      { key: 'name', label: 'Nombre sensor' },
      { key: 'sensorTypeName', label: 'Tipo Sensor' },
      { key: 'address', label: 'Localización' },
      { key: 'statusName', label: 'Estado' },
      {
        key: undefined,
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        // toRender: {
        //   component: IconComponent,
        //   data: {
        //     icon: Icon.edit,
        //     alt: 'icono lápiz acción editar',
        //   },
        // },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
    ],
    [GridTypeEnum.ManageVariableMessaging]: [
      { key: 'id', label: 'Id', cellInteger: true },
      { key: 'name', label: 'Nombre' },
      { key: 'address', label: 'Localización' },
      { key: 'stateName', label: 'Estado' },
      {
        key: undefined,
        label: '',
      },
      {
        key: undefined,
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.edit,
            alt: 'icono lápiz acción editar',
          },
        },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
      {
        key: undefined, label: 'Acciones', cellClass: 'cursor-pointer fx-cell-hover',
        dispatcher: dispatchers?.at(1),
      },
    ],
    [GridTypeEnum.ManagePMV]: [
      { key: 'id', label: 'Id', cellInteger: true },
      { key: 'direccion', label: 'Nombre' },
      { key: 'tipo', label: 'Localización' },
      { key: 'lugar', label: 'Estado' },
      { key: 'estado', label: 'Estado' },
      {
        key: undefined,
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.edit,
            alt: 'icono lápiz acción editar',
          },
        },
        dispatcher: dispatchers ? dispatchers.at(0) : undefined,
      },
    ],
  
    [GridTypeEnum.ManageIncidents]: [
      { key: 'id', label: 'Id', cellInteger: true },
      { key: 'situationName', label: '-' },
      { key: 'location', label: '' },
      { key: 'categoryName', label: '' },
      { key: 'subcategoryName', label: '' },
      { key: 'sourceName', label: '' },
      { key: 'stateName', label: '' },
      {
        key: undefined,
        label: '',
      },
      {
        key: undefined,
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        // toRender: {
        //   component: IconComponent,
        //   data: {
        //     icon: Icon.edit,
        //     alt: 'icono lápiz acción editar',
        //   },
        // },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
    ],
    [GridTypeEnum.PMVconsulta]: [
      { key: 'index', label: 'Id', cellInteger: true },
      { key: 'message', label: 'Mensaje' },
      { key: 'localTime', label: 'Fecha Programación' },
    ],
    [GridTypeEnum.PMVEditar]: [
      { key: 'messageNumber', label: 'Id', cellInteger: true },
      { key: 'message', label: 'Mensaje' },
      {
        key: 'isActive',
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        toRender: {
          component: StateToogleComponent,
        },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
      {
        key: undefined,
        label: '',
        cellClass: 'gridcolum cursor-pointer fx-cell-hover pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.edit,
            alt: 'icono lápiz acción editar',
          },
        },
        dispatcher: dispatchers ? dispatchers[1] : undefined,
      },
      {
        key: undefined,
        label: '',
        cellClass: 'gridcolum cursor-pointer fx-cell-hover pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.delete,
            alt: 'icono canasto acción borrar',
          },
        },
        dispatcher: dispatchers ? dispatchers[2] : undefined,
      },
    ],
    [GridTypeEnum.PMVEditarProgramados]: [
      { key: 'index', label: 'Id', cellInteger: true },
      { key: 'message', label: 'Mensaje' },
      { key: 'localTime', label: 'Fecha Inicio' },
      {
        key: undefined,
        label: 'Acciones',
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.edit,
            alt: 'icono lápiz acción editar',
          },
        },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
      {
        key: undefined,
        label: '',
        cellClass: 'gridcolum cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.delete,
            alt: 'icono canasto acción borrar',
          },
        },
        dispatcher: dispatchers ? dispatchers[1] : undefined,
      },
    ],
    [GridTypeEnum.RoleManage]: [
      { key: 'name', label: 'Rol' },
      { key: 'icon', label: 'Icono' },
      {
        key: 'edit',
        label: 'Acciones',
        span: 1,
        cellClass: 'no-width cursor-pointer fx-cell-hover',
        headerClass: 'pr-8',
        toRender: {
          component: IconComponent,
          data: {
            icon: Icon.edit,
            alt: 'Icono lápiz acción editar',
          },
        },
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      }
    ],
    [GridTypeEnum.ManageUserAudit]: [
      { key: 'userRealName', label: 'header' },
      { key: 'actionDate', label: 'Fecha y hora de creación:' },
      { key: 'auditType', label: 'Acción:' },
      {
        key: undefined,
        label: undefined,
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
    ],
    [GridTypeEnum.ManageRecordAudit]: [
      { key: 'name', label: 'header' },
      { key: 'actionDate', label: 'Fecha y hora de creación:' },
      { key: 'auditType', label: 'Acción:' },
      {
        key: undefined,
        label: undefined,
        cellClass: 'cursor-pointer fx-cell-hover pr-8',
        headerClass: 'pr-8',
        dispatcher: dispatchers ? dispatchers[0] : undefined,
      },
    ],
    [GridTypeEnum.ManageGridUserAudit]: [
      { key: 'revId', label: 'Id. Auditoria' },
      { key: 'creationDate', label: 'Fecha/hora registro auditoria' },
      { key: 'id', label: 'Id. de registro' },
      { key: 'name', label: 'Funcionario' },
      { key: 'auditType', label: 'Acción' },
    ],
    [GridTypeEnum.ManageGridRecordAudit]: [
      { key: 'revId', label: 'Id. Auditoria' },
      { key: 'creationDate', label: 'Fecha/hora registro auditoria' },
      { key: 'id', label: 'Id. de registro' },
      { key: 'name', label: 'Funcionario' },
      { key: 'auditType', label: 'Acción' },
    ],
  });
